// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__tBKcj","ltr":"Card_ltr__2ZA71","Content":"Card_Content__1KdA0","icon":"Card_icon__3-OZK"};